import React, { useEffect, useState } from 'react';
import { CheckCircle2, AlertTriangle, Info, X } from 'lucide-react';
import { APP_ALERT_EVENT } from '../../utils/appAlert';

const STYLES = {
  success: {
    shell: 'border-emerald-200 bg-emerald-50 text-emerald-900',
    icon: 'text-emerald-600',
    Icon: CheckCircle2
  },
  warning: {
    shell: 'border-amber-200 bg-amber-50 text-amber-900',
    icon: 'text-amber-600',
    Icon: AlertTriangle
  },
  info: {
    shell: 'border-brand-orange-200 bg-brand-orange-50 text-brand-black',
    icon: 'text-brand-black',
    Icon: Info
  },
  error: {
    shell: 'border-red-200 bg-red-50 text-red-900',
    icon: 'text-red-600',
    Icon: AlertTriangle
  }
};

const AppAlertHost = () => {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    const handleAlert = (event) => {
      const payload = event.detail;
      if (!payload?.message) return;

      setAlerts((current) => [...current, payload]);

      window.setTimeout(() => {
        setAlerts((current) => current.filter((item) => item.id !== payload.id));
      }, 4000);
    };

    window.addEventListener(APP_ALERT_EVENT, handleAlert);
    return () => window.removeEventListener(APP_ALERT_EVENT, handleAlert);
  }, []);

  const dismissAlert = (id) => {
    setAlerts((current) => current.filter((item) => item.id !== id));
  };

  return (
    <div className="fixed top-5 right-5 z-[200] flex flex-col gap-3 w-[min(92vw,380px)]">
      {alerts.map((alert) => {
        const alertStyle = STYLES[alert.type] || STYLES.error;
        const Icon = alertStyle.Icon;

        return (
          <div
            key={alert.id}
            className={`rounded-2xl border shadow-lg px-4 py-4 backdrop-blur-sm ${alertStyle.shell}`}
          >
            <div className="flex items-start gap-3">
              <div className={`mt-0.5 ${alertStyle.icon}`}>
                <Icon className="w-5 h-5" />
              </div>
              <div className="flex-1 min-w-0">
                {alert.title && (
                  <p className="text-sm font-black tracking-tight">{alert.title}</p>
                )}
                <p className="text-sm font-semibold leading-6">{alert.message}</p>
              </div>
              <button
                type="button"
                onClick={() => dismissAlert(alert.id)}
                className="text-current/60 hover:text-current transition-colors"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AppAlertHost;
